export const FUNNEL_STORAGE_KEY = "troopn-funnel-preferences-v1";

export const QUIZ_INTERESTS = [
  "hiking",
  "food",
  "wine",
  "art",
  "beaches",
  "nightlife",
  "museums",
  "adventure",
  "local_culture",
  "music",
  "spa",
  "photography",
] as const;

export type Pace = "slow" | "moderate" | "aggressive";
export type Budget = "budget" | "moderate" | "premium" | "luxury";
export type FunnelStage = "signup" | "intro" | "style" | "basics" | "interests" | "done";

export type FunnelDraft = {
  stage?: FunnelStage;
  archetypeId?: string | null;
  pace?: Pace | null;
  budget?: Budget | null;
  interests?: string[];
  ownerId?: string | null;
  saveAfterAuth?: boolean;
};

export const STAGE_ORDER: FunnelStage[] = ["intro", "style", "basics", "interests", "done"];

export function readSavedDraft(): FunnelDraft {
  try {
    const raw = sessionStorage.getItem(FUNNEL_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as FunnelDraft;
    return {
      stage: STAGE_ORDER.includes(parsed.stage as FunnelStage) ? parsed.stage : "signup",
      archetypeId: typeof parsed.archetypeId === "string" ? parsed.archetypeId : null,
      pace: ["slow", "moderate", "aggressive"].includes(parsed.pace ?? "") ? parsed.pace : null,
      budget: ["budget", "moderate", "premium", "luxury"].includes(parsed.budget ?? "") ? parsed.budget : null,
      interests: Array.isArray(parsed.interests) ? parsed.interests.filter((interest) => typeof interest === "string").slice(0, 8) : [],
      ownerId: typeof parsed.ownerId === "string" ? parsed.ownerId : null,
      saveAfterAuth: parsed.saveAfterAuth === true,
    };
  } catch {
    return {};
  }
}
